import { Link, NavLink } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { REPORT_MODE } from "../config";

const linkBase =
  "text-sm font-semibold transition-colors duration-150";

export default function Header() {
  const { user, logout } = useAuth();

  const navClass = ({ isActive }) =>
    `${linkBase} ${isActive ? "text-[#FF6B1A]" : "text-white/80 hover:text-[#FF6B1A]"}`;

  return (
    <header
      className="sticky top-0 z-50 backdrop-blur-xl bg-black/70 border-b border-white/5"
      data-testid="site-header"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-8 h-20 flex items-center justify-between gap-6">
        <Link to="/" className="flex items-center gap-3 shrink-0" data-testid="logo-link">
          <div className="relative w-11 h-11 rounded-full bg-black border-2 border-[#FF6B1A] flex items-center justify-center overflow-hidden shadow-[0_0_18px_-4px_rgba(46,229,157,0.6)]">
            <img
              src="https://customer-assets.emergentagent.com/job_festurban-live/artifacts/l19s6upi_logo%20action%20impact%20jeunesse.png"
              alt="Action Impact Jeunesse"
              className="w-9 h-9 rounded-full object-cover"
            />
          </div>
          <span className="font-bold text-lg sm:text-xl tracking-wide">
            URBAN <span className="text-[#FF6B1A]">FEST</span>
          </span>
        </Link>

        <nav className="hidden lg:flex items-center gap-8" data-testid="main-nav">
          <NavLink to="/" end className={navClass} data-testid="nav-home">ACCUEIL</NavLink>
          <NavLink to="/programme" className={navClass} data-testid="nav-programme">PROGRAMME</NavLink>
          <NavLink to="/classement" className={navClass} data-testid="nav-classement">CLASSEMENT</NavLink>
          <NavLink to="/galerie" className={navClass} data-testid="nav-galerie">GALERIE</NavLink>
          <NavLink to="/inscription" className={navClass} data-testid="nav-inscription">INSCRIPTION</NavLink>
          <NavLink to="/contact" className={navClass} data-testid="nav-contact">CONTACT</NavLink>
        </nav>

        <div className="flex items-center gap-3">
          {user && user.role === "admin" ? (
            <>
              <Link to="/admin" className="hidden sm:inline-flex text-sm font-semibold text-[#FF6B1A]" data-testid="nav-admin">ADMIN</Link>
              <button
                onClick={logout}
                className="text-xs font-semibold text-white/60 hover:text-[#FF3B30] uppercase tracking-wider"
                data-testid="logout-btn"
              >
                Déconnexion
              </button>
            </>
          ) : REPORT_MODE ? (
            <span className="text-xs font-black uppercase tracking-widest text-[#FFB800] border border-[#FFB800]/50 rounded-full px-4 py-2" data-testid="header-report-badge">
              Reporté
            </span>
          ) : (
            <Link to="/inscription" className="btn-brutal !py-2 !px-5 !text-xs" data-testid="header-cta">
              S'inscrire
            </Link>
          )}
        </div>
      </div>

      {/* Mobile bar */}
      <nav className="lg:hidden flex overflow-x-auto gap-5 px-4 pb-3 border-t border-white/5" data-testid="mobile-nav">
        {[
          { to: "/", label: "Accueil", end: true, t: "nav-home-m" },
          { to: "/programme", label: "Programme", t: "nav-programme-m" },
          { to: "/classement", label: "Classement", t: "nav-classement-m" },
          { to: "/galerie", label: "Galerie", t: "nav-galerie-m" },
          { to: "/inscription", label: "Inscription", t: "nav-inscription-m" },
          { to: "/contact", label: "Contact", t: "nav-contact-m" },
        ].map((n) => (
          <NavLink key={n.to} to={n.to} end={n.end} className={navClass} data-testid={n.t}>
            {n.label.toUpperCase()}
          </NavLink>
        ))}
      </nav>
    </header>
  );
}
